import axios from "axios";
import useAuthStore from "../store/authStore";

export function setupAxiosInterceptors() {
  // Add request interceptor for version header
  axios.interceptors.request.use(
    (config) => {
      const { currentUser } = useAuthStore.getState();
      if (currentUser) {
        config.headers["X-User-FirstName"] = currentUser.firstName;
        config.headers["X-User-LastName"] = currentUser.lastName;
      }
      config.headers["X-App-Version"] = __APP_VERSION__;

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Existing response interceptor
  axios.interceptors.response.use(
    (response) => {
      if (
        response.data.code === 8000 ||
        response.data.code === 8001 ||
        response.data.code === 8002 ||
        response.data.code === 8003
      ) {
        const { logout } = useAuthStore.getState();
        logout();
      }
      return response;
    },
    (error) => {
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        window.location.href = "/login";
      }

      return Promise.reject(error);
    }
  );
}
